import { render, staticRenderFns } from "./pcUserNavComponent.vue?vue&type=template&id=c9e80f14&scoped=true"
import script from "./pcUserNavComponent.vue?vue&type=script&lang=js"
export * from "./pcUserNavComponent.vue?vue&type=script&lang=js"
import style0 from "./pcUserNavComponent.vue?vue&type=style&index=0&id=c9e80f14&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e80f14",
  null
  
)

export default component.exports